const PurchaseOrderType = {
  SET_PURCHASE_ORDER: 'SET_PURCHASE_ORDER',
  SET_MODAL_COLOURWAYSLIST: 'SET_MODAL_COLOURWAYSLIST',
  SET_MODAL_SUPPLIERLIST: 'SET_MODAL_SUPPLIERLIST',
  SET_MODAL_PO_TEMPLATE: 'SET_MODAL_PO_TEMPLATE',
  SET_PROFILE: 'SET_PROFILE',
  SET_PO_DETAILS: 'SET_PO_DETAILS',
  SET_CREATE_PO_PERMISSION: 'SET_CREATE_PO_PERMISSION',
  SET_TRADE_REF: 'SET_TRADE_REF',
  GET_EDITED_DATA: 'GET_EDITED_DATA',
  SET_MATERIAL_PLACEMENT: 'SET_MATERIAL_PLACEMENT',
  SET_LEG_LENGTH: 'SET_LEG_LENGTH',
  SET_SZES: 'SET_SZES',
  SET_DEVORDER_DATA: 'SET_DEVORDER_DATA',
  DOCUMENT_LIST: 'DOCUMENT_LIST',
  DATES_LIST: 'DATES_LIST',
  SET_PO_HISTORY_DATA: 'SET_PO_HISTORY_DATA',
  SET_PO_LOG_DATA: 'SET_PO_LOG_DATA',
  PREVIEW_DATA: 'PREVIEW_DATA',
  PREVIEW_DEV_DATA: 'PREVIEW_DEV_DATA',
  EMPTY_PREVIEW: 'EMPTY_PREVIEW',
  SET_OLD_PO_PREVIEW_DATA: 'SET_OLD_PO_PREVIEW_DATA',
};
export default PurchaseOrderType;
